<template>
  <router-view />
</template>

<script>
import { mapGetters } from 'vuex'

import { NEXT_TASTING_STEP } from '@/store/modules/tasting/types'

export default {
  name: 'TastingSection',
  mounted() {
    const onSummary = this.$router.currentRoute.name === 'section-summary'

    if (!this.step && !onSummary) {
      this.$store.dispatch(NEXT_TASTING_STEP)
    }
  },
  updated() {
    const onSummary = this.$router.currentRoute.name === 'section-summary'

    if (!this.step && !onSummary) {
      this.$store.dispatch(NEXT_TASTING_STEP)
    }
  },
  computed: {
    ...mapGetters({ step: 'currentTastingStep' })
  }
}
</script>

<style lang="scss" scoped>
.image {
  width: 50%;
  margin: 20px auto;

  img {
    width: 100%;
  }
}

.question {
  margin-top: 15px;
}
</style>
